import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-entites',
  templateUrl: './table-entites.component.html',
  styleUrls: ['./table-entites.component.scss'],
})
export class TableEntitesComponent implements OnInit {
  @Input() scroll: any = { x: '1100px', y: '100%' };

  constructor() {}

  ngOnInit(): void {}
}
